import { render } from "./BorderedTextarea.vue?vue&type=template&id=b9e7f952&ts=true"
import script from "./BorderedTextarea.vue?vue&type=script&lang=ts"
export * from "./BorderedTextarea.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__